import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class ProfileCategory {
  constructor (params = {}) {
    const {
      id,
      sequence,
      name,
      externalIds,
      attributes
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.name = name || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.attributes = attributes || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      attributes: item.attributes
    }
  }
}
